import { render, staticRenderFns } from "./paymentVerify.vue?vue&type=template&id=5dd4acdf"
import script from "./paymentVerify.vue?vue&type=script&lang=js"
export * from "./paymentVerify.vue?vue&type=script&lang=js"
import style0 from "./paymentVerify.vue?vue&type=style&index=0&id=5dd4acdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports